import { matches, stubString } from "lodash";
import Tab from "../../plugins/tab.js";

const PAGE_SCHEDULE = document.querySelector(".page-schedule");
const NAV_ITEMS = Array.from(
  document.querySelectorAll(".l-contents-schedule-list__item")
);
const MONTH = Array.from(
  document.querySelectorAll(".p-member-month-categories__item")
);

const scroll_elements = document.querySelectorAll(".js-scroll-tab");
for (const element of scroll_elements) {
  new Tab(element, {
    defaultOpenPanel: 1,
  });
}

if (PAGE_SCHEDULE) {
   NAV_ITEMS.forEach((e) => {
     e.addEventListener("click", () => {
       location.hash = e.dataset.year;
     });
   });
    const hash = location.hash;
    const regex = /^#\d{4}(-\d{1,2})?$/g;
    const matchs = hash.match(regex);
    if (matchs) {
      let param = matchs.shift().slice(1);
      let tabdata = param.substring(0, 4);
      let array = new Array();
      NAV_ITEMS.forEach((e) => {
        array.push(e.dataset.year);
      });
      let tabIndex = array.indexOf(tabdata);

      if (tabIndex >= 0) {
        const scroll_elements = document.querySelectorAll(".js-scroll-tab");
        for (const element of scroll_elements) {
          new Tab(element, {
            defaultOpenPanel: tabIndex,
          });
        }
      } else {
        const scroll_elements = document.querySelectorAll(".js-scroll-tab");
        for (const element of scroll_elements) {
          new Tab(element, {
            defaultOpenPanel: 1,
          });
        }
      }
    } else {
      const scroll_elements = document.querySelectorAll(".js-scroll-tab");
      for (const element of scroll_elements) {
        new Tab(element, {
          defaultOpenPanel: 1,
        });
      }
    };

  MONTH.forEach((e) => {
    e.addEventListener("click", (i) => {
      let hashdata = e.hash;
      i.preventDefault();
      let param = hashdata.slice(1);
      let tabdata = param.substring(0, 4);
      let array = new Array();
      NAV_ITEMS.forEach((e) => {
        array.push(e.dataset.year);
      });
      let tabIndex = array.indexOf(tabdata);
      const scroll_elements = document.querySelectorAll(".js-scroll-tab");
      for (const element of scroll_elements) {
        new Tab(element, {
          defaultOpenPanel: tabIndex,
        });
        location.hash = hashdata;
      }
    });
  });
}

// } else {
//   const scroll_elements = document.querySelectorAll(".js-scroll-tab");
//   for (const element of scroll_elements) {
//     new Tab(element, {
//       defaultOpenPanel: 1,
//     });
//   }

//  if (PAGE_SCHEDULE) {
//    NAV_ITEMS.forEach((e) => {
//      e.addEventListener("click", () => {
//        location.hash = e.dataset.year;
//      });
//    });
//      const hash = location.hash;
//      const regex = /^#\d{4}(-\d{1,2})?$/g;
//      const matchs = hash.match(regex)
//      if (matchs) {
//        let param = matchs.shift().slice(1);
//        let tabdata = param.substring(0, 4);
//        let array = new Array();
//        NAV_ITEMS.forEach((e) => {
//          array.push(e.dataset.year);
//        });
//        let tabIndex = array.indexOf(tabdata);

//       if (tabIndex >= 0) {
//         const scroll_elements = document.querySelectorAll(".js-scroll-tab");
//         for (const element of scroll_elements) {
//           new Tab(element, {
//             defaultOpenPanel: tabIndex,
//           });
//         }
//       } else {
//         const scroll_elements = document.querySelectorAll(".js-scroll-tab");
//         for (const element of scroll_elements) {
//           new Tab(element, {
//             defaultOpenPanel: 1,
//           });
//          }
//        }
//      } else {
//        const scroll_elements = document.querySelectorAll(".js-scroll-tab");
//        for (const element of scroll_elements) {
//          new Tab(element, {
//            defaultOpenPanel: 1,
//          });
//        }
//      }
//  }
// console.log(location.hash)
